import { TranslateLoader, TranslateModuleConfig } from "@ngx-translate/core";
import { HttpClient } from "@angular/common/http";
import { CustomTranslateHttpLoader } from "./custom-translate-http-loader";

export function withGastTranslateConfig(paths: string[], suffix = ".json"): TranslateModuleConfig {
  const translationsLoaderFactory: (http: HttpClient) => TranslateLoader = (http: HttpClient) => {
    return new CustomTranslateHttpLoader(http, paths, suffix);
  };

  return {
    loader: {
      provide: TranslateLoader,
      useFactory: translationsLoaderFactory,
      deps: [HttpClient],
    },
  };
}
